import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortText',
  standalone: true,
})
export class ShortTextPipe implements PipeTransform {
  transform(value: string, displayLength: number, replacedBy = '...'): string {
    if (!value || value.length <= displayLength) {
      return value;
    }
    return `${value.slice(0, displayLength).trim()}${replacedBy}`;
  }
}
